module.exports = __webpack_public_path__ + "img/maria.8873643a.png";